import { useEffect } from 'react';

import { IframeTarget } from '~src/bootstrap/types';
import { useIpc } from '~src/utils/ipc-utils';

export const useAriaTitle = (title: string, target: IframeTarget, cond: boolean = true) => {
  const ipc = useIpc();

  useEffect(() => {
    if (cond) {
      ipc.send({
        name: 'set_iframe_title',
        data: {
          title,
          target,
        },
      });
    }

    return () => {
      if (target === 'fullscreen') {
        ipc.send({ name: 'unset_iframe_title', data: { target } });
      }
    };
  }, [cond]);
};
